import { ShanXi } from '@/project-subject/subject-config/shan-xi/shan-xi'
import { MingTing } from '@/project-subject/subject-config/ming-ting/ming-ting'
import { AgentGeneral } from '@/project-subject/subject-config/agent-general/agent-general'

export interface SubjectListItem {
  /** id */
  id: string
  /** 主体名称 - 调试用不对外 */
  debug_subject_name: string
  /** 域名 */
  domains: string[],
  /** logo-登录页 */
  logo_login_page: any,
  /** logo-控制台头部 */
  logo_dashboard_header: any,
  /** logo-控制台头部（暗模式） */
  logo_dashboard_header_dark: any,
  /** 电话-售前 */
  phone_pre_sale: string,
  /** 电话-售后 */
  phone_after_sale: string,
  /** 邮箱 */
  mail: string,
  /** http请求的签名app_id */
  sign_app_id: string
  /** http请求的签名key */
  sign_key: string
}

export const SubjectMap = {
  MingTing,
  ShanXi,
  AgentGeneral,
}
